export default "__VITE_PUBLIC_ASSET__c45743a1__"